import app from "../_app";

const nav = document.querySelector('.js-nav');
const header = document.querySelector('.header');

if(nav) {
    if(app.viewport.isSmallerThan('lg')) {
        const navItems = [...nav.querySelectorAll('.js-nav-item')];
        const backTriggers = [...nav.querySelectorAll('.js-nav-back')];
        const navTriggers = [...document.querySelectorAll('.js-nav-trigger')];
        const searchField = document.querySelector('.js-mobile-search-nav');

        const navItemClickHandler = (e) => {
            e.preventDefault();

            e.currentTarget.nextElementSibling.setAttribute('data-open', '');
        };

        const backClickHandler = (e) => {
            e.currentTarget.closest('.js-nav-sub-nav').removeAttribute('data-open');
        };

        const triggerClickHandler = () => {
            if(nav.hasAttribute('data-open')) {
                const openSubNavs = [...nav.querySelectorAll('.js-nav-sub-nav[data-open]')];

                nav.removeAttribute('data-open');

                openSubNavs.map(openSubNav => openSubNav.removeAttribute('data-open'));

                app.unlockBody();
                header.classList.remove('nav-open');

            } else {
                app.lockBody();
                nav.setAttribute('data-open', '');
                header.classList.add('nav-open');
            }
        };

        navItems.map(navItem => navItem.firstElementChild.addEventListener('click', navItemClickHandler));
        backTriggers.map(backTrigger => backTrigger.addEventListener('click', backClickHandler));
        navTriggers.map(navTrigger => navTrigger.addEventListener('click', triggerClickHandler));
    } else {
        const navItemsElement = nav.querySelector('.js-nav-items');
        const navTopItems = [...nav.querySelectorAll('.js-nav-top-item')];

        const navMoreItemsElement = nav.querySelector('.js-nav-more-items');
        const navMoreItems = [...nav.querySelectorAll('.js-nav-more-item')];


        const handleNavSize = (size) => {
            let itemsWidth = 0;
            let fitIndex = 0;

            navTopItems.map(item => {
                item.classList.remove('d-none');
                itemsWidth += item.clientWidth;

                if((itemsWidth + ((fitIndex + 1) * 32)) < size) {
                    fitIndex++;
                } else {
                    item.classList.add('d-none');
                }
            });

            if(fitIndex < navTopItems.length) {
                navTopItems?.[fitIndex - 1]?.classList.add('d-none');
                navMoreItemsElement.classList.remove('d-none');
            } else {
                navMoreItemsElement.classList.add('d-none');
            }

            navMoreItems.map((item, index) => {
                if(index >= fitIndex - 1) {
                    item.classList.remove('d-none');
                } else {
                    item.classList.add('d-none');
                }
            });
        }

        let lastNavItemsWidth = navItemsElement.clientWidth;

        handleNavSize(lastNavItemsWidth);
        new ResizeObserver((entries) => {
            entries.forEach(entry => {
                const width = entry.borderBoxSize?.[0].inlineSize;

                if(typeof width === 'number' && width !== lastNavItemsWidth) {
                    lastNavItemsWidth = width;

                    handleNavSize(lastNavItemsWidth);
                }
            });
        }).observe(navItemsElement);
    }

    nav.removeAttribute('data-loading');
}
